export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS"
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE"
export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST"


export const GET_CART_SUCCESS = "GET_CART_SUCCESS"
export const GET_CART_FAILURE = "GET_CART_FAILURE"
export const GET_CART_REQUEST = "GET_CART_REQUEST"

export const DELETE_CART_REQUEST = "DELETE_CART_REQUEST"
export const DELETE_CART_SUCCESS = "DELETE_CART_SUCCESS"
export const DELETE_CART_FAILURE = "DELETE_CART_FAILURE"


export const PATCH_CART_SUCCESS = "PATCH_CART_SUCCESS"
export const PATCH_CART_REQUEST = "PATCH_CART_REQUEST"
export const PATCH_CART_FAILURE = "PATCH_CART_FAILURE"
